import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import './i18n/config';
import { MenuProvider } from './context/MenuContext';
import { OnboardingProvider } from './context/OnboardingContext';
import store, { persistor } from './Redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import { setupAxiosInterceptors } from './Services/AxiosInterceptor';

// Initialize global Axios interceptors for automatic request cancellation.
// This must run before any API calls so all requests are tracked.
setupAxiosInterceptors();


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <BrowserRouter>
        <MenuProvider>
          <OnboardingProvider>
            <App />
          </OnboardingProvider>
        </MenuProvider>
      </BrowserRouter>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(//  console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
